// DeviceBadge — a small brand-colored icon badge for the device family the
// customer first ordered/uploaded from (orders.device, captured by the worker
// first-non-null-wins). Mirrors SourceBadge's round-logo styling so the two
// read consistently side-by-side in the admin orders list + detail.
import type { IconType } from 'react-icons';
import { FaApple, FaAndroid, FaDesktop, FaMobileAlt, FaTabletAlt } from 'react-icons/fa';

interface DeviceVisual {
  label: string;
  Icon: IconType;
  fg: string;
  bg: string;
}

// Keys match the worker's VALID_DEVICES set / detectDevice() output.
const DEVICES: Record<string, DeviceVisual> = {
  iPhone:  { label: 'iPhone',  Icon: FaApple,      fg: '#FFFFFF', bg: '#1C1C1E' },
  iPad:    { label: 'iPad',    Icon: FaTabletAlt,  fg: '#FFFFFF', bg: '#1C1C1E' },
  Android: { label: 'Android', Icon: FaAndroid,    fg: '#FFFFFF', bg: '#3DDC84' },
  Mobile:  { label: 'Mobile',  Icon: FaMobileAlt,  fg: '#FFFFFF', bg: '#6B7280' },
  Desktop: { label: 'Desktop', Icon: FaDesktop,    fg: '#FFFFFF', bg: '#475569' },
};

export function deviceLabel(device: string | null | undefined): string {
  if (!device) return '';
  return DEVICES[device]?.label ?? device;
}

/** A round device-icon badge. Null / unknown device → renders nothing. */
export function DeviceBadge({
  device,
  size = 20,
}: {
  device: string | null | undefined;
  size?: number;
}) {
  if (!device) return null;
  const v = DEVICES[device];
  if (!v) return null;
  const Icon = v.Icon;
  return (
    <span
      title={`Appareil : ${v.label}`}
      aria-label={`Appareil : ${v.label}`}
      className="inline-flex shrink-0 items-center justify-center rounded-full ring-1 ring-black/5"
      style={{ width: size, height: size, background: v.bg }}
    >
      <Icon style={{ color: v.fg }} size={Math.round(size * 0.58)} />
    </span>
  );
}
